import { render, staticRenderFns } from "./RefundDetails.vue?vue&type=template&id=251b267b&"
import script from "./RefundDetails.vue?vue&type=script&lang=js&"
export * from "./RefundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports